import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useEffect } from "react";

const MonthlyUploadSuccessModal = ({ open, onClose }) => {
  useEffect(() => {
    if (!open) return;
    const timeoutId = setTimeout(onClose, 7000);
    return () => clearTimeout(timeoutId);
  }, [open, onClose]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" sx={{ zIndex: 1204 }}>
      <DialogTitle>Upload Submitted</DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          Your file has been submitted and is being processed. Once processing is complete, an email notification will be sent to you.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MonthlyUploadSuccessModal;
